// extracted by mini-css-extract-plugin
export default {"Header":"Header_Header__wwyjE","activeLink":"Header_activeLink__-W+SD"};